import { CircleAlert } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CriticalIcon = createLucideIcon(CircleAlert);
